<template>
    <div id="tab-forms-packages-container">
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdButton
                    v-bind:Label="$t('PPDbSetup.FormsPackagesTab.AddPackage')"
                    v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="addPackage"
                    v-bind:Name="'btn_add_package'"
                >
                </MdButton>
            </b-col>
            <b-col lg="9" md="9" sm="12">
                <div class="textlabel" :data-label="$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="searchPackages"
                        />
                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="searchPackages"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <b-row>
            <b-col class="col-12 mt-2">
                <MdTable
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                    :editIconEvent="editPackage"
                    v-bind:VisibleEditIcon="true"
                    :deleteIconEvent="deletePackage"
                    v-bind:VisibleDeleteIcon="true"
                >
                </MdTable>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import PatientPortalNotePackageHdrsService from '@/services/patientPortalNotePackageHdrs.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';

export default {
    name: 'TabFormsPackages',
    mixins: [ShowMessage, DBFunctions],
    data() {
        return {
            items: [],
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            fields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-left'
                },
                {
                    key: 'noteCount',
                    sortable: true,
                    label: this.$t('PPDbSetup.FormsPackagesTab.NoteCount'),
                    class: 'text-center'
                }
            ],
            showMessageIsEmpty: false,
            parameter: {
                SearchCriteria: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },
    methods: {
        addPackage() {
            this.$router.push({ name: 'patient-portal-note-package-add' });
        },

        editPackage(row) {
            this.$router.push({
                name: 'patient-portal-note-package-edit',
                params: { id: row.packageId }
            });
        },

        deletePackage(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_package'
                })
                .then(value => {
                    if (value) {
                        PatientPortalNotePackageHdrsService.delete(row.packageId)
                            .then(() => {
                                this.currentPage = 1;
                                this.listingAsync();
                            })
                            .catch(error => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                });
        },

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        searchPackages() {
            this.currentPage = 1;
            this.listingAsync();
        },

        async listingAsync() {
            const parameters = {
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                SearchCriteria: this.parameter.SearchCriteria
            };

            await PatientPortalNotePackageHdrsService.getAll(parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        const header = JSON.parse(response.headers['x-pagination']);
                        this.totalRows = header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.totalRows === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    },
    async mounted() {
        await this.listingAsync();
    }
};
</script>
